////jc  without image
import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import {
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
  Spinner,
  CardHeader,
} from "reactstrap";
import { Btn } from "../../../AbstractElements";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import axios, { AxiosError } from "axios";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import { parsePhoneNumberFromString, CountryCode } from "libphonenumber-js";
import { baseUrl, uploadFile, mediaUrl } from "../../../Utils/FileUpload";
import {
  ChooseFile,
  Submit,
  ContactNumber,
  Email,
  Address,
  EditAgentTitle,
  AgentTitle,
} from "../../../Utils/Constants";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MultiSelect } from "react-multi-select-component";
import { useNavigate, useLocation } from "react-router-dom";
import useCustomToasts from "../../../hooks/useCustomToast";
interface FormValues {
  agent_name: string;
  phone: string;
  email: string;
  address: string;
  image: FileList | null;
  language_id: string[]; // changed to array
  brand_id: string[]; // changed to array
  password: string;
  documents: {
    name: string;
    image: FileList | null;
  }[];
  bankingdetail?: string;
}

interface ErrorResponse {
  message: string;
}

interface Language {
  id: string;
  language: string;
  icon: string;
}

interface Brand {
  id: string;
  brand_name: string;
  icon: string;
}
export default function EditAgent() {
  const [loading, setLoading] = useState(true);
  const {
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: {
      agent_name: "",
      phone: "",
      email: "",
      address: "",
      image: null,
      language_id: [],
      brand_id: [],
      password: "",
      documents: [{ name: "", image: null }],
      bankingdetail: "",
    },
  });
  const [existingFile, setExistingFile] = useState<string>("");
  const location = useLocation();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [language, setLanguage] = useState<Language[]>([]);
  const [brand, setBrand] = useState<Brand[]>([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const { SuccessToast, ErrorToast } = useCustomToasts(navigate);
  const [phoneInputValue, setPhoneInputValue] = useState<string>("");
  const [documentPreviews, setDocumentPreviews] = useState<{
    [key: string]: { src: string; type: string };
  }>({});
  const agentRef = useRef<any>(null);
  // for documents list
  const { fields, append, remove } = useFieldArray({
    control,
    name: "documents",
  });
  const validatePhoneNumber = (value: string) => {
    if (!value) {
      return "Phone number is required.";
    }

    const sanitizedValue = value.replace(/\D/g, ""); // remove non-digits
    const phoneNumber = parsePhoneNumberFromString(`+${sanitizedValue}`);

    if (!phoneNumber || !phoneNumber.isValid()) {
      return "Invalid phone number.";
    }

    const allowedCountries: CountryCode[] = ["IN", "SA", "AE"];
    if (!allowedCountries.includes(phoneNumber.country as CountryCode)) {
      return "Only Indian, Saudi Arabian, or UAE numbers are allowed.";
    }

    return true;
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseUrl}language/getall`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const filteredLanguage = response.data.filter(
          (brand: any) => brand.is_deleted === 0 && brand.is_active === 1
        );
        setLanguage(filteredLanguage);
        // console.log(data);
        const result = await axios.get(`${baseUrl}brand/getall`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const filteredBrand = result.data.filter(
          (brand: any) => brand.is_deleted === 0 && brand.is_active === 1
        );
        setBrand(filteredBrand);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true);
      try {
        const result = await axios.post(
          `${baseUrl}agent/viewbyid`,
          { id: location.state.id },
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const agent = result.data;
        agentRef.current = agent; // Save for use in useEffect
        // console.log(agent);
        const documentsData =
          agent.documents?.map((doc: any) => ({
            name: doc.name || "",
            image: doc.image || null,
          })) || [];

        // Reset the entire form including documents and other fields
        reset({
          agent_name: agent.agent_name || "",
          image: agent.image || null,
          email: agent.email || "",
          phone: agent.phone || "",
          address: agent.address || "",
          bankingdetail: agent.bankingdetail || "",
          brand_id: agent.brands?.map((b: any) => b.id) || [],
          language_id: agent.languages?.map((l: any) => l.id) || [],
          documents: documentsData,
        });
setPhoneInputValue(agent.phone || "");
        setExistingFile(agent.image);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching details:", error);
        setLoading(false);
      }
    };

    fetchDetails();
  }, [location.state.id]);

  useEffect(() => {
    if (!fields.length || !agentRef.current) return;

    const previews: Record<string, { src: string; type: string }> = {};

    fields.forEach((field, index) => {
      const doc = agentRef.current.documents?.[index];
      if (doc?.image) {
        // Handle both File object and string URL
        let fileName = "";

        if (typeof doc.image === "string") {
          fileName = doc.image;
        } else if (doc.image instanceof File) {
          fileName = doc.image.name;
        } else {
          console.warn("Invalid image type at index", index, doc.image);
          return;
        }

        const ext = fileName.split(".").pop()?.toLowerCase();
        const type = ext === "pdf" ? "pdf" : "image";

        previews[field.id] = {
          src:
            typeof doc.image === "string"
              ? `${mediaUrl}/${doc.image}`
              : URL.createObjectURL(doc.image),
          type,
        };
      }
    });

    setDocumentPreviews((prev) => ({ ...prev, ...previews }));
  }, [fields]);

  const onSubmit = async (data: FormValues) => {
    setIsButtonDisabled(true);
    try {
      let filename = existingFile;

      // Upload main image if provided
      if (
        data.image &&
        data.image instanceof FileList &&
        data.image.length > 0
      ) {
        const file = data.image[0];
        filename = await uploadFile(file);
        setExistingFile(filename);
      }

      // Handle documents: Upload each file and store name + uploaded filename
      const uploadedDocuments = await Promise.all(
        data.documents.map(async (doc) => {
          let docFilename = "";

          // Case 1: FileList (from input[type=file])
          if (
            doc.image &&
            doc.image instanceof FileList &&
            doc.image.length > 0
          ) {
            const file = doc.image[0];
            docFilename = await uploadFile(file);
          }

          // Case 2: File object (from existing data or state)
          else if (doc.image instanceof File) {
            docFilename = await uploadFile(doc.image);
          }

          // Case 3: Already uploaded (string)
          else if (typeof doc.image === "string") {
            docFilename = doc.image;
          }

          return {
            name: doc.name,
            image: docFilename,
          };
        })
      );

      const editdata = {
        id: location.state.id,
        agent_name: data.agent_name,
        phone: data.phone,
        email: data.email,
        address: data.address,
        image: filename,
        language_id: data.language_id,
        brand_id: data.brand_id,
        bankingdetail: data.bankingdetail,
        password: data.password || "",
        documents: uploadedDocuments,
      };
      // console.log(editdata, "edit");
      const token = localStorage.getItem("token");
      const response = await axios.post(`${baseUrl}agent/update`, editdata, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        SuccessToast("Agent updated successfully", "/view_agent");
      } else {
        toast.error("Failed to update");
      }
    } catch (err) {
      const axiosError = err as AxiosError;
      const errorResponse = axiosError.response?.data as ErrorResponse;
      const errorMessage =
        errorResponse?.message || "An unexpected error occurred";
      console.error("Error:", errorMessage);
      toast.error(errorMessage);
    } finally {
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 2000);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner color="primary" />
      </div>
    );
  }

  // Prevent form submission on Enter key press
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <>
      <Breadcrumbs
        pageTitle={EditAgentTitle}
        parent={AgentTitle}
        title={EditAgentTitle}
      />
      <Col xl={12} className="mb-lg-3">
        <Card>
          <CardBody className="custom-input form-validation">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row className="g-3">
                <Col xs={6}>
                  <Label htmlFor="agent-name">Agent Name</Label>
                  <Controller
                    name="agent_name"
                    control={control}
                    rules={{
                      required: "Agent is required",
                    }}
                    render={({ field }) => (
                      <>
                        <Input
                          id="agent-name"
                          type="text"
                          placeholder="Agent Name"
                          {...field}
                          invalid={!!errors.agent_name}
                          style={{
                            color: "var(--input-text-color)",
                            borderColor: errors.agent_name ? "red" : "",
                          }}
                          autoComplete="off"
                          onKeyDown={handleKeyDown}
                        />
                        {errors.agent_name && (
                          <FormFeedback>
                            {errors.agent_name.message}
                          </FormFeedback>
                        )}
                      </>
                    )}
                  />
                </Col>

                <Col xs={6}>
                  <Label htmlFor="phone">Phone</Label>
                  <Controller
                    name="phone"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) => validatePhoneNumber(value),
                    }}
                    render={({ field }) => (
                      <>
                        <PhoneInput
                          country={"in"} // default country
                          onlyCountries={["in", "sa", "ae"]} // restrict to India, KSA, UAE
                          disableDropdown={false}
                          countryCodeEditable={false}
                          value={phoneInputValue}
                          onChange={(value) => {
                            const sanitizedValue = value.replace(/\D/g, "");
                            setPhoneInputValue(sanitizedValue);
                            field.onChange(sanitizedValue);
                          }}
                          inputProps={{
                            id: "phone",
                            placeholder: "Enter phone number",
                            style: {
                              backgroundColor: "var(--input-background-color)",
                              color: "var(--input-text-color)",
                              width: "100%",
                              borderColor: errors.phone
                                ? "red"
                                : "var(--input-border-color, #e0e0e0)",
                            },
                            autoComplete: "off",
                          }}
                          dropdownStyle={{
                            backgroundColor: "var(--input-background-color)",
                            backdropFilter: "blur(1000px)",
                          }}
                          buttonStyle={{
                            backgroundColor: "var(--input-background-color)",
                          }}
                          specialLabel=""
                          onKeyDown={handleKeyDown}
                        />
                        {errors.phone && (
                          <FormFeedback
                            style={{ display: "block", color: "red" }}
                          >
                            {errors.phone.message}
                          </FormFeedback>
                        )}
                      </>
                    )}
                  />
                </Col>

                <Col xs={6}>
                  <Label htmlFor="email">Email</Label>
                  <Controller
                    name="email"
                    control={control}
                    rules={{
                      required: "Email is required",
                      pattern: {
                        value:
                          /^[a-zA-Z0-9]+([._%+-][a-zA-Z0-9]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/,
                        message:
                          "Invalid email address. Please enter a valid email.",
                      },
                    }}
                    render={({ field }) => (
                      <>
                        <Input
                          type="email"
                          id="email"
                          placeholder="Email"
                          {...field}
                          invalid={!!errors.email}
                          style={{
                            color: "var(--input-text-color)",
                            borderColor: errors.email ? "red" : "",
                          }}
                          autoComplete="off"
                          onKeyDown={handleKeyDown}
                        />
                        {errors.email && (
                          <FormFeedback>{errors.email.message}</FormFeedback>
                        )}
                      </>
                    )}
                  />
                </Col>

                <Col xs={6}>
                  <Label htmlFor="address">Address</Label>
                  <Controller
                    name="address"
                    control={control}
                    rules={{ required: "Address is required" }}
                    render={({ field }) => (
                      <>
                        <Input
                          type="textarea"
                          id="address"
                          placeholder="Address"
                          {...field}
                          invalid={!!errors.address}
                          style={{
                            color: "var(--input-text-color)",
                            borderColor: errors.address ? "red" : "",
                          }}
                          onKeyDown={handleKeyDown}
                          autoComplete="off"
                        />
                        {errors.address && (
                          <FormFeedback>{errors.address.message}</FormFeedback>
                        )}
                      </>
                    )}
                  />
                </Col>

                <Col xs={6}>
                  <Label htmlFor="brand_id">Brand</Label>
                  <Controller
                    name="brand_id"
                    control={control}
                    rules={{ required: "Please select at least one brand" }}
                    render={({ field }) => {
                      const options = brand.map((b: any) => ({
                        label: b.brand_name,
                        value: b.id,
                      }));

                      return (
                        <>
                          <div
                            style={{
                              border: errors.brand_id
                                ? "1px solid red"
                                : "1px solid var(--input-border-color, #ccc)",
                              borderRadius: "4px",
                            }}
                          >
                            <MultiSelect
                              options={options}
                              value={options.filter((opt) =>
                                field.value?.includes(opt.value)
                              )}
                              onChange={(
                                selected: {
                                  label: string;
                                  value: string | number;
                                }[]
                              ) =>
                                field.onChange(selected.map((opt) => opt.value))
                              }
                              labelledBy="Select Brands"
                              hasSelectAll={false}
                              overrideStrings={{
                                selectSomeItems: "Select Brand(s)...",
                              }}
                            />
                          </div>
                          {errors.brand_id && (
                            <div className="text-danger mt-1 d-block">
                              {errors.brand_id.message}
                            </div>
                          )}
                        </>
                      );
                    }}
                  />
                </Col>

                <Col xs={6}>
                  <Label htmlFor="language_id">Language</Label>
                  <Controller
                    name="language_id"
                    control={control}
                    rules={{ required: "Please select at least one language" }}
                    render={({ field }) => {
                      const options = language.map((b: any) => ({
                        label: b.language,
                        value: b.id,
                      }));

                      return (
                        <>
                          <div
                            style={{
                              border: errors.language_id
                                ? "1px solid red"
                                : "1px solid var(--input-border-color, #ccc)",
                              borderRadius: "4px",
                            }}
                          >
                            <MultiSelect
                              options={options}
                              value={options.filter((opt) =>
                                field.value?.includes(opt.value)
                              )}
                              onChange={(
                                selected: {
                                  label: string;
                                  value: string | number;
                                }[]
                              ) =>
                                field.onChange(selected.map((opt) => opt.value))
                              }
                              labelledBy="Select Languages"
                              hasSelectAll={false}
                              overrideStrings={{
                                selectSomeItems: "Select Language(s)...",
                              }}
                            />
                          </div>
                          {errors.language_id && (
                            <div className="text-danger mt-1">
                              {errors.language_id.message}
                            </div>
                          )}
                        </>
                      );
                    }}
                  />
                </Col>

                <Col xs={12}>
                  <Card
                    className="mb-4"
                    style={{ border: "1px solid #ced4da", borderRadius: "8px" }}
                  >
                    <CardHeader
                      tag="h5"
                      style={{
                        backgroundColor: "#f8f9fa",
                        borderBottom: "1px solid #ced4da",
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                      }}
                    >
                      Documents Details
                    </CardHeader>
                    <CardBody>
                      {fields.map((doc, index) => (
                        <Row key={doc.id} className="mb-2">
                          <Col xs={6}>
                            <Label>Document Name</Label>
                            <Controller
                              name={`documents.${index}.name`}
                              control={control}
                              rules={{ required: "Document name required" }}
                              render={({ field }) => (
                                <Input
                                  placeholder="Document Name"
                                  {...field}
                                  invalid={!!errors.documents?.[index]?.name}
                                  style={{
                                    color: "var(--input-text-color)",
                                    borderColor: errors.documents?.[index]?.name
                                      ? "red"
                                      : "",
                                  }}
                                  autoComplete="off"
                                  onKeyDown={handleKeyDown}
                                />
                              )}
                            />
                            {errors.documents?.[index]?.name && (
                              <FormFeedback>
                                {errors.documents[index]?.name?.message}
                              </FormFeedback>
                            )}
                          </Col>

                          <Col xs={6}>
                            <Label>Upload Document</Label>
                            <Controller
                              name={`documents.${index}.image`}
                              control={control}
                              rules={{
                                required: "Image or PDF file is required",
                              }}
                              render={({
                                field: { onChange, onBlur, ref },
                              }) => (
                                <>
                                  <Input
                                    type="file"
                                    accept="image/*,.pdf"
                                    placeholder="Select file"
                                    onChange={(e) => {
                                      const files = e.target.files;
                                      if (files && files[0]) {
                                        const file = files[0];
                                        const reader = new FileReader();
                                        const isPDF =
                                          file.type === "application/pdf";

                                        reader.onloadend = () => {
                                          setDocumentPreviews((prev) => ({
                                            ...prev,
                                            [fields[index].id]: {
                                              src: reader.result as string,
                                              type: isPDF ? "pdf" : "image",
                                            },
                                          }));
                                        };

                                        reader.readAsDataURL(file);
                                        onChange(file);
                                      }
                                    }}
                                    onBlur={onBlur}
                                    innerRef={ref}
                                    invalid={!!errors.documents?.[index]?.image}
                                    style={{
                                      borderColor: errors.documents?.[index]
                                        ?.image
                                        ? "red"
                                        : "",
                                    }}
                                  />

                                  {/* Validation Error */}
                                  {!!errors.documents?.[index]?.image && (
                                    <div className="invalid-feedback d-block">
                                      {errors.documents[index]?.image?.message}
                                    </div>
                                  )}

                                  {/* Preview (image or PDF) */}
                                  {documentPreviews[fields[index].id] &&
                                    documentPreviews[fields[index].id].type ===
                                      "image" && (
                                      <img
                                        src={
                                          documentPreviews[fields[index].id].src
                                        }
                                        alt="Preview"
                                        width="70"
                                        height="70"
                                        style={{
                                          marginTop: "5px",
                                          borderRadius: "10px",
                                        }}
                                      />
                                    )}

                                  {documentPreviews[fields[index].id] &&
                                    documentPreviews[fields[index].id].type ===
                                      "pdf" && (
                                      <iframe
                                        src={
                                          documentPreviews[fields[index].id].src
                                        }
                                        // type="application/pdf"
                                        width="100%"
                                        height="100px"
                                        allow="fullscreen"
                                        style={{
                                          marginTop: "5px",
                                          borderRadius: "10px",
                                        }}
                                      />
                                    )}
                                </>
                              )}
                            />
                          </Col>

                          <Col xs={2}>
                            {fields.length > 1 && index !== 0 && (
                              <Btn
                                color="danger"
                                size="sm"
                                onClick={() => {
                                  const docIdToRemove = fields[index].id;
                                  // console.log("Removing ID:", docIdToRemove);

                                  // ✅ 1. Remove preview
                                  setDocumentPreviews((prev) => {
                                    const updated = { ...prev };
                                    delete updated[docIdToRemove];
                                    // console.log("Updated previews:", updated);
                                    return updated;
                                  });

                                  // ✅ 2. Remove document from agentRef
                                  if (agentRef.current?.documents) {
                                    agentRef.current.documents.splice(index, 1);
                                  }

                                  // ✅ 3. Remove field from react-hook-form
                                  remove(index);
                                }}
                              >
                                Remove
                              </Btn>
                            )}
                          </Col>
                        </Row>
                      ))}

                      <Btn
                        size="sm"
                        onClick={() => append({ name: "", image: null })}
                      >
                        + Add Document
                      </Btn>
                    </CardBody>
                  </Card>
                </Col>

                <Col xs={12}>
                  <Card
                    className="mb-4"
                    style={{ border: "1px solid #ced4da", borderRadius: "8px" }}
                  >
                    <CardHeader
                      tag="h5"
                      style={{
                        backgroundColor: "#f8f9fa",
                        borderBottom: "1px solid #ced4da",
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                      }}
                    >
                      Banking Details
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col xs={12} className="mb-2">
                          <Controller
                            name="bankingdetail"
                            control={control}
                            rules={{ required: "Banking details are required" }}
                            render={({ field }) => (
                              <>
                                <Input
                                  type="textarea"
                                  id="bankingdetail"
                                  placeholder="Enter all banking details here"
                                  {...field}
                                  invalid={!!errors.bankingdetail}
                                  style={{
                                    color: "var(--input-text-color)",
                                    borderColor: errors.bankingdetail
                                      ? "red"
                                      : "",
                                    minHeight: "120px",
                                  }}
                                  autoComplete="off"
                                  onKeyDown={handleKeyDown}
                                />
                                {errors.bankingdetail && (
                                  <FormFeedback>
                                    {errors.bankingdetail.message}
                                  </FormFeedback>
                                )}
                              </>
                            )}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                <Col xs={6}>
                  <Label htmlFor="formFile">Photo</Label>
                  <Controller
                    name="image"
                    control={control}
                    rules={{ required: "Image is required" }}
                    render={({ field: { onChange, onBlur, ref } }) => (
                      <>
                        <Input
                          id="formImage"
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                              onChange(e.target.files);
                              // Update the image preview immediately
                              const reader = new FileReader();
                              reader.onloadend = () => {
                                setExistingFile(reader.result as string);
                              };
                              reader.readAsDataURL(file);
                            }
                          }}
                          onBlur={onBlur}
                          innerRef={ref}
                          invalid={!!errors.image}
                          style={{ borderColor: errors.image ? "red" : "" }}
                          onKeyDown={handleKeyDown}
                        />
                        {errors.image && (
                          <FormFeedback>{errors.image.message}</FormFeedback>
                        )}
                        {existingFile && (
                          <img
                            src={
                              existingFile.startsWith("data:")
                                ? existingFile
                                : `${mediaUrl}/${existingFile}`
                            }
                            alt="Preview"
                            width="70"
                            height="70"
                            style={{ marginTop: "5px", borderRadius: "10px" }}
                          />
                        )}
                      </>
                    )}
                  />
                </Col>

                <Col xs={12} className="mt-2">
                  <Btn color="primary" disabled={isButtonDisabled}>
                    {Submit}
                  </Btn>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
      <ToastContainer
        toastStyle={{
          userSelect: "none",
        }}
      />
    </>
  );
}

// // ////jc  with image
// import React, { useState, useEffect, useRef } from "react";
// import { useForm, Controller, useFieldArray } from "react-hook-form";
// import {
//   Card,
//   CardBody,
//   Col,
//   Form,
//   Input,
//   Label,
//   Row,
//   FormFeedback,
//   Spinner,
//   CardHeader,
// } from "reactstrap";
// import { Btn } from "../../../AbstractElements";
// import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
// import axios, { AxiosError } from "axios";
// import "react-phone-input-2/lib/style.css";
// import PhoneInput from "react-phone-input-2";
// import { parsePhoneNumberFromString, CountryCode } from "libphonenumber-js";
// import { baseUrl, uploadFile, mediaUrl } from "../../../Utils/FileUpload";
// import {
//   ChooseFile,
//   Submit,
//   ContactNumber,
//   Email,
//   Address,
//   EditAgentTitle,
//   AgentTitle,
// } from "../../../Utils/Constants";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { MultiSelect } from "react-multi-select-component";
// import { useNavigate, useLocation } from "react-router-dom";
// import useCustomToasts from "../../../hooks/useCustomToast";

// interface FormValues {
//   image: FileList | null;
//   documents: {
//     name: string;
//     image: FileList | null;
//   }[];
// }

// interface ErrorResponse {
//   message: string;
// }

// interface Language {
//   id: string;
//   language: string;
//   icon: string;
// }

// interface Brand {
//   id: string;
//   brand_name: string;
//   icon: string;
// }
// export default function EditAgent() {
//   const [loading, setLoading] = useState(true);
//   const {
//     handleSubmit,
//     setValue,
//     control,
//     reset,
//     formState: { errors },
//   } = useForm<FormValues>({
//     defaultValues: {
//       image: null,
//       documents: [{ name: "", image: null }],
//     },
//   });
//   const [existingFile, setExistingFile] = useState<string>("");
//   const location = useLocation();
//   const [isButtonDisabled, setIsButtonDisabled] = useState(false);
//   const [language, setLanguage] = useState<Language[]>([]);
//   const [brand, setBrand] = useState<Brand[]>([]);
//   const navigate = useNavigate();
//   const token = localStorage.getItem("token");
//   const { SuccessToast, ErrorToast } = useCustomToasts(navigate);
//   const [phoneInputValue, setPhoneInputValue] = useState<string>("");
//   const [documentPreviews, setDocumentPreviews] = useState<{
//     [key: string]: string;
//   }>({});
//   const agentRef = useRef<any>(null);
//   // for documents list
//   const { fields, append, remove } = useFieldArray({
//     control,
//     name: "documents",
//   });

//   useEffect(() => {
//     const fetchDetails = async () => {
//       setLoading(true);
//       try {
//         const result = await axios.post(
//           `${baseUrl}agent/viewbyid`,
//           { id: location.state.id },
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         const agent = result.data;
//         agentRef.current = agent; // Save for use in useEffect

//         const documentsData =
//           agent.documents?.map((doc: any) => ({
//             name: doc.name || "",
//             image: doc.image || null,
//           })) || [];

//         reset({
//           image: agent.image || null,
//           documents: documentsData,
//         });

//         setExistingFile(agent.image);
//         setLoading(false);
//       } catch (error) {
//         console.error("Error fetching details:", error);
//         setLoading(false);
//       }
//     };

//     fetchDetails();
//   }, [location.state.id]);
// useEffect(() => {
//   if (!fields.length || !agentRef.current) return;

//   const previews: Record<string, string> = {};
//   fields.forEach((field, index) => {
//     const doc = agentRef.current.documents?.[index];
//     if (doc?.image) {
//       previews[field.id] = `${mediaUrl}/${doc.image}`;
//     }
//   });

//   setDocumentPreviews((prev) => ({ ...prev, ...previews }));
// }, [fields]);

//   const onSubmit = async (data: FormValues) => {
//     setIsButtonDisabled(true);
//     try {
//       let filename = existingFile;

//       // Upload main image if provided
//       if (
//         data.image &&
//         data.image instanceof FileList &&
//         data.image.length > 0
//       ) {
//         const file = data.image[0];
//         filename = await uploadFile(file);
//         setExistingFile(filename);
//       }

//       // Handle documents: Upload each file and store name + uploaded filename
//       const uploadedDocuments = await Promise.all(
//         data.documents.map(async (doc) => {
//           let docFilename = "";
//           if (
//             doc.image &&
//             doc.image instanceof FileList &&
//             doc.image.length > 0
//           ) {
//             const file = doc.image[0];
//             docFilename = await uploadFile(file);
//           }
//           return {
//             name: doc.name,
//             image: docFilename || doc.image,
//           };
//         })
//       );

//       const editdata = {
//         id: location.state.id,
//         image: filename,
//         documents: uploadedDocuments,
//       };
//       console.log(editdata, "edit");
//       const token = localStorage.getItem("token");
//       const response = await axios.post(`${baseUrl}agent/update`, editdata, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       if (response.status === 200) {
//         SuccessToast("Agent updated successfully", "/view_agent");
//       } else {
//         toast.error("Failed to update");
//       }
//     } catch (err) {
//       const axiosError = err as AxiosError;
//       const errorResponse = axiosError.response?.data as ErrorResponse;
//       const errorMessage =
//         errorResponse?.message || "An unexpected error occurred";
//       console.error("Error:", errorMessage);
//       toast.error(errorMessage);
//     } finally {
//       setTimeout(() => {
//         setIsButtonDisabled(false);
//       }, 2000);
//     }
//   };

//   if (loading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <Spinner color="primary" />
//       </div>
//     );
//   }

//   // Prevent form submission on Enter key press
//   const handleKeyDown = (e: React.KeyboardEvent) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//     }
//   };

//   return (
//     <>
//       <Breadcrumbs
//         pageTitle={EditAgentTitle}
//         parent={AgentTitle}
//         title={EditAgentTitle}
//       />
//       <Col xl={12} className="mb-lg-3">
//         <Card>
//           <CardBody className="custom-input form-validation">
//             <Form onSubmit={handleSubmit(onSubmit)}>
//               <Row className="g-3">
//                 <Col xs={12}>
//                   <Card
//                     className="mb-4"
//                     style={{ border: "1px solid #ced4da", borderRadius: "8px" }}
//                   >
//                     <CardHeader
//                       tag="h5"
//                       style={{
//                         backgroundColor: "#f8f9fa",
//                         borderBottom: "1px solid #ced4da",
//                         borderTopLeftRadius: "10px",
//                         borderTopRightRadius: "10px",
//                       }}
//                     >
//                       Documents Details
//                     </CardHeader>
//                     <CardBody>
//                       {fields.map((doc, index) => (
//                         <Row key={doc.id} className="mb-2">
//                           <Col xs={6}>
//                             <Label>Document Name</Label>
//                             <Controller
//                               name={`documents.${index}.name`}
//                               control={control}
//                               rules={{ required: "Document name required" }}
//                               render={({ field }) => (
//                                 <Input
//                                   placeholder="Document Name"
//                                   {...field}
//                                   invalid={!!errors.documents?.[index]?.name}
//                                   style={{
//                                     color: "var(--input-text-color)",
//                                     borderColor: errors.documents?.[index]?.name
//                                       ? "red"
//                                       : "",
//                                   }}
//                                   autoComplete="off"
//                                   onKeyDown={handleKeyDown}
//                                 />
//                               )}
//                             />
//                             {errors.documents?.[index]?.name && (
//                               <FormFeedback>
//                                 {errors.documents[index]?.name?.message}
//                               </FormFeedback>
//                             )}
//                           </Col>

//                           <Col xs={6}>
//                             <Label>Upload Document</Label>
//                             <Controller
//                               name={`documents.${index}.image`}
//                               control={control}
//                               rules={{ required: "Image file is required" }}
//                               render={({
//                                 field: { onChange, onBlur, ref },
//                               }) => (
//                                 <>
//                                   <Input
//                                     type="file"
//                                     accept="image/*"
//                                     placeholder="Select file"
//                                     onChange={(e) => {
//                                       const files = e.target.files;
//                                       if (files && files[0]) {
//                                         const reader = new FileReader();
//                                         reader.onloadend = () => {
//                                         setDocumentPreviews((prev) => ({
//   ...prev,
//   [doc.id]: reader.result as string,
// }));
//                                         };
//                                         reader.readAsDataURL(files[0]);
//                                         onChange(files); // update react-hook-form
//                                       }
//                                     }}
//                                     onBlur={onBlur}
//                                     innerRef={ref}
//                                     invalid={!!errors.documents?.[index]?.image}
//                                     style={{
//                                       borderColor: errors.documents?.[index]
//                                         ?.image
//                                         ? "red"
//                                         : "",
//                                     }}
//                                   />
//                                   {!!errors.documents?.[index]?.image && (
//                                     <div className="invalid-feedback d-block">
//                                       {errors.documents[index]?.image?.message}
//                                     </div>
//                                   )}
//                                   {documentPreviews[doc.id] && (
//                                     <img
//                                       src={documentPreviews[doc.id]}
//                                       alt="Document Preview"
//                                       width="70"
//                                       height="70"
//                                       style={{
//                                         marginTop: "5px",
//                                         borderRadius: "10px",
//                                       }}
//                                     />
//                                   )}
//                                 </>
//                               )}
//                             />
//                           </Col>

//                           <Col xs={2}>
//                             {fields.length > 1 && (
//                               <Btn
//                                 color="danger"
//                                 size="sm"
//                                 onClick={() => {
//                                   const docIdToRemove = fields[index].id;
//                                   console.log("Removing ID:", docIdToRemove);

//                                   // ✅ 1. Remove preview
//                                   setDocumentPreviews((prev) => {
//                                     const updated = { ...prev };
//                                     delete updated[docIdToRemove];
//                                     console.log("Updated previews:", updated);
//                                     return updated;
//                                   });

//                                   // ✅ 2. Remove document from agentRef
//                                   if (agentRef.current?.documents) {
//                                     agentRef.current.documents.splice(index, 1);
//                                   }

//                                   // ✅ 3. Remove field from react-hook-form
//                                   remove(index);
//                                 }}
//                               >
//                                 Remove
//                               </Btn>
//                             )}
//                           </Col>
//                         </Row>
//                       ))}

//                       <Btn
//                         size="sm"
//                         onClick={() => append({ name: "", image: null })}
//                       >
//                         + Add Document
//                       </Btn>
//                     </CardBody>
//                   </Card>
//                 </Col>
//                 <Col xs={12} className="mt-2">
//                   <Btn color="primary" disabled={isButtonDisabled}>
//                     {Submit}
//                   </Btn>
//                 </Col>
//               </Row>
//             </Form>
//           </CardBody>
//         </Card>
//       </Col>
//     </>
//   );
// }
